export default __webpack_public_path__ + "static/media/dice.c3f96f11.png";